export enum RequestStatus {
    idle = 0,
    loading = 1 << 0,
    succeeded = 1 << 1,
    failed = 1 << 2
}